// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createAccountReport from "./account/postAccountReport";
import createChatInvitationAccept from "./chatInvitation/postChatInvitationAccept";
import createChatInvitationDecline from "./chatInvitation/postChatInvitationDecline";
import createChatInvitationList from "./chatInvitation/postChatInvitationList";
import createChatCreateStandalone from "./chat/postChatCreateStandalone";
import createChatDeleteForMe from "./chat/postChatDeleteForMe";
import createChatDeleteStandalone from "./chat/postChatDeleteStandalone";
import createChatGet from "./chat/postChatGet";
import createChatGetOrCreatePrivate from "./chat/postChatGetOrCreatePrivate";
import createChatInviteMembers from "./chat/postChatInviteMembers";
import createChatLeave from "./chat/postChatLeave";
import createChatListFiles from "./chat/postChatListFiles";
import createChatListMedia from "./chat/postChatListMedia";
import createChatListMembers from "./chat/postChatListMembers";
import createChatListMine from "./chat/postChatListMine";
import createChatListPins from "./chat/postChatListPins";
import createChatListSuggestedPeople from "./chat/postChatListSuggestedPeople";
import createChatMarkRead from "./chat/postChatMarkRead";
import createChatMemberTimeoutClear from "./chat/postChatMemberTimeoutClear";
import createChatMemberTimeoutSet from "./chat/postChatMemberTimeoutSet";
import createChatPromoteAdmin from "./chat/postChatPromoteAdmin";
import createChatRemoveMember from "./chat/postChatRemoveMember";
import createChatSetPostPolicy from "./chat/postChatSetPostPolicy";
import createChatUpdate from "./chat/postChatUpdate";
import createGifSearch from "./gif/postGifSearch";
import createMessageRequestApprove from "./messageRequest/postMessageRequestApprove";
import createMessageRequestDecline from "./messageRequest/postMessageRequestDecline";
import createMessageRequestList from "./messageRequest/postMessageRequestList";
import createMessageDelete from "./message/postMessageDelete";
import createMessageEdit from "./message/postMessageEdit";
import createMessageList from "./message/postMessageList";
import createMessagePin from "./message/postMessagePin";
import createMessageReport from "./message/postMessageReport";
import createMessageSend from "./message/postMessageSend";
import createMessageUnpin from "./message/postMessageUnpin";
import createPollVote from "./poll/postPollVote";
import createReactionList from "./reaction/postReactionList";
import createReactionSet from "./reaction/postReactionSet";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postAccountReport: createAccountReport(resolvedOptions),
    postChatInvitationAccept: createChatInvitationAccept(resolvedOptions),
    postChatInvitationDecline: createChatInvitationDecline(resolvedOptions),
    postChatInvitationList: createChatInvitationList(resolvedOptions),
    postChatCreateStandalone: createChatCreateStandalone(resolvedOptions),
    postChatDeleteForMe: createChatDeleteForMe(resolvedOptions),
    postChatDeleteStandalone: createChatDeleteStandalone(resolvedOptions),
    postChatGet: createChatGet(resolvedOptions),
    postChatGetOrCreatePrivate: createChatGetOrCreatePrivate(resolvedOptions),
    postChatInviteMembers: createChatInviteMembers(resolvedOptions),
    postChatLeave: createChatLeave(resolvedOptions),
    postChatListFiles: createChatListFiles(resolvedOptions),
    postChatListMedia: createChatListMedia(resolvedOptions),
    postChatListMembers: createChatListMembers(resolvedOptions),
    postChatListMine: createChatListMine(resolvedOptions),
    postChatListPins: createChatListPins(resolvedOptions),
    postChatListSuggestedPeople: createChatListSuggestedPeople(resolvedOptions),
    postChatMarkRead: createChatMarkRead(resolvedOptions),
    postChatMemberTimeoutClear: createChatMemberTimeoutClear(resolvedOptions),
    postChatMemberTimeoutSet: createChatMemberTimeoutSet(resolvedOptions),
    postChatPromoteAdmin: createChatPromoteAdmin(resolvedOptions),
    postChatRemoveMember: createChatRemoveMember(resolvedOptions),
    postChatSetPostPolicy: createChatSetPostPolicy(resolvedOptions),
    postChatUpdate: createChatUpdate(resolvedOptions),
    postGifSearch: createGifSearch(resolvedOptions),
    postMessageRequestApprove: createMessageRequestApprove(resolvedOptions),
    postMessageRequestDecline: createMessageRequestDecline(resolvedOptions),
    postMessageRequestList: createMessageRequestList(resolvedOptions),
    postMessageDelete: createMessageDelete(resolvedOptions),
    postMessageEdit: createMessageEdit(resolvedOptions),
    postMessageList: createMessageList(resolvedOptions),
    postMessagePin: createMessagePin(resolvedOptions),
    postMessageReport: createMessageReport(resolvedOptions),
    postMessageSend: createMessageSend(resolvedOptions),
    postMessageUnpin: createMessageUnpin(resolvedOptions),
    postPollVote: createPollVote(resolvedOptions),
    postReactionList: createReactionList(resolvedOptions),
    postReactionSet: createReactionSet(resolvedOptions),
  };
}
